import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
// import { useNavigate } from 'react-router-dom';
import { _showStates } from '../../../App';
import { updateSettings } from '../../firestoreData/settings/updateSettings';
import { appSettingsHandlers, appSettingsInitialState, appSettingsReducer } from '../reducers/AppSettingsReducer';
import { AppParentContext } from './AppParentContext';
import { AuthContext } from './AuthContext';
import { DatabaseContext } from './DatabaseContext';
import { ServiceWorkerContext, _appVersion, _useCache } from './ServiceWorkerContext';
import { useAppUser } from './useHelpers/useAppUser';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';
// import { useNavigate } from 'react-router-dom';

export const AppSettingsContext = createContext();

/**
 * Simple wrapper to handle app settings changes
 */
const AppSettingsProvider = (props) => {

  const { hashPath } = props ?? {}

  const appUserAccess = useAppUserAccess()

  // functionsContext
  const appParentContext = useContext(AppParentContext);
  const { states, fn_cls } = appParentContext ?? {}
  const { app_state } = states ?? {}
  const { mainDb, currentEnvironment } = app_state ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext)
  const { database_fns, database_handlers } = databaseContext ?? {}

  // serviceWorkerContext
  const serviceWorkerContext = useContext(ServiceWorkerContext)
  const { serviceWorker_state } = serviceWorkerContext ?? {}
  const { cache_info } = serviceWorker_state ?? {}
  const { cacheFetched, cache_groups } = cache_info ?? {}
  const { cache_settings } = cache_groups ?? {}

  // authContext
  const authContext = useContext(AuthContext)
  const { auth_state } = authContext ?? {}
  const { currentAuthUser } = auth_state ?? {}
  const { uid: authUid } = currentAuthUser ?? {}

  const init_state = { appUser: appUserAccess, fn_cls, currentEnvironment, mainDb, database_fns, hashPath, authUid, cache_settings: _useCache.settings ? cache_settings : null }
  const [appSettings_state, appSettings_dispatch] = useReducer(appSettingsReducer, appSettingsInitialState(init_state))
  const { prodOverrideOn } = appSettings_state ?? {}

  useEffect(() => {
    if (prodOverrideOn) {
      database_handlers.handleChange_databaseApp(prodOverrideOn)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [prodOverrideOn]);

  const appSettings_handlers = useMemo(
    () => appSettingsHandlers(appSettings_dispatch),
    [appSettings_dispatch]
  );

  if (_showStates.any && _showStates.appSettings) {
    console.log('--- appSettings ---')
    console.log(Object.keys(appSettings_state))
    console.log(Object.keys(appSettings_handlers))
  }

  const checkAppSetting = () => {
    console.log('checkSetting', appSettings_state)
  }

  const fns = {
    checkAppSetting,
    ...updateSettings(database_fns, mainDb)
  }

  return <AppSettingsContext.Provider value={{ appSettings_state, appSettings_handlers, appSettings_fns: fns, appVersion: _appVersion }}>
    {props.children}
  </AppSettingsContext.Provider>
};

export default AppSettingsProvider